import { Grid, Typography } from '@mui/material'
import { useLoadOrderClientCredit } from 'modules/orders/hooks/useLoadOrderClientCredit'
import { useFormContext } from 'react-hook-form'
import { formatCurrency } from 'utils'

export const Credit = () => {
  const { watch } = useFormContext()

  const [customer] = watch(['customer'])

  const { data: orderClientCredit } = useLoadOrderClientCredit({
    customerId: customer?.id
  })

  const creditLimit = orderClientCredit?.data?.creditLimit || 0
  const usedLimit = orderClientCredit?.data?.usedLimit || 0
  let availableCredit = creditLimit - usedLimit
  availableCredit = availableCredit > 0 ? availableCredit : 0

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={4}>
          <Typography variant="caption" gutterBottom>
            Total
          </Typography>
          <Typography style={{ fontSize: 14, fontWeight: 500 }}>
            {formatCurrency(creditLimit)}
          </Typography>
        </Grid>
        <Grid item xs={4}>
          <Typography variant="caption" gutterBottom>
            Utilizado
          </Typography>
          <Typography style={{ fontSize: 14, fontWeight: 500 }}>
            {formatCurrency(usedLimit)}
          </Typography>
        </Grid>
        <Grid item xs={4}>
          <Typography variant="caption" gutterBottom>
            Disponível
          </Typography>
          <Typography style={{ fontSize: 14, fontWeight: 500 }}>
            {formatCurrency(availableCredit)}
          </Typography>
        </Grid>
      </Grid>
    </>
  )
}
